(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleDetailController', TestScheduleDetailController);

    TestScheduleDetailController.$inject = ['$scope', '$rootScope', 'entity', 'DataUtils'];

    function TestScheduleDetailController($scope, $rootScope, entity, DataUtils) {
        var vm = this;
        vm.testSchedule = entity;

        var unsubscribe = $rootScope.$on('jotApp:testScheduleUpdate', function (event, result) {
            vm.testSchedule = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

    }
})();
